import React from "react";
import {
  CommunityFeedType,
  CommunityProps,
  CommunityUserFeed,
} from "../../types";
import { convertTimestamp } from "../../utils/timeConverter";
import { Link } from "react-router-dom";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { CiUser } from "react-icons/ci";

type DiscussMenuProps = {
  communityFeed: CommunityFeedType | undefined;
  community: CommunityProps;
  comUserFeed?: CommunityUserFeed;
  type?: string
};

const DiscussMenu: React.FC<Partial<DiscussMenuProps>> = ({
  communityFeed,
  community,
  comUserFeed,
  type
}) => {
  const PostTime = convertTimestamp(communityFeed?.createdAt);
  const add = "+ad4e_nj";
  const profilePics = communityFeed?.creator?.ecobookProfile?.profileImage;

  // console.log(profilePics, "profilePics");

  return (
    <Link
      to={`/ecobook/profile/${communityFeed?.creator.id}${add}`}
      className="flex w-[70%] gap-2 mb-2 font-Poppins"
    >
      {communityFeed?.creator?.ecobookProfile &&
      communityFeed?.creator?.ecobookProfile?.profileImage ? (
        <img
          src={ipfsGatewayImage(profilePics!)}
          alt=""
          className="w-10 h-10 rounded-full"
        />
      ) : (
        <div className="w-10 h-10 bg-slate-100 flex items-center justify-center rounded-full">
          <CiUser size={20} />
        </div>
      )}
      <div className="flex h-9 flex-col w-[90%] lg:w-[70%]">
        <div className="text-[#222] font-medium text-xs">
          {`${communityFeed?.creator.firstName} ${communityFeed?.creator.lastName}`}
        </div>
        <div className="flex gap-1 items-center font-light">
          <div className="rounded-sm bg-[#2157590D] py-[2px] px-1 text-pretty flex justify-center items-center lg:text-[10px] text-[8px] text-midGreen">
            {type === 'UserFeedCommunity'
              ? `${communityFeed?.community?.name} COMMUNITY`
              : communityFeed?.creator?.roles!}
          </div>
          <div className="lg:text-[11px] p-[2px] text-CoolGrey text-[8px] text-pretty ">{PostTime}</div>
        </div>
      </div>
    </Link>
  );
};

export default DiscussMenu;
